import React from 'react';
import { useSelector } from 'react-redux';

import {
    isUserLoggedIn,
    shouldHideLogin,
} from '~shared/utils/user';
import {
    selectShowBetReceipt,
} from '~Betslip/selectors/betReceiptSelectors';

import BetslipCTAs from './BetslipCTAs';
import ReceiptCTAs from './ReceiptCTAs';

const CallToActions = () => {
    const showBetReceipt = useSelector(selectShowBetReceipt);

    if (shouldHideLogin()) {
        return null;
    }

    if (showBetReceipt && isUserLoggedIn()) {
        return <ReceiptCTAs />;
    }

    return <BetslipCTAs />;
};

export default CallToActions;
